import axiosInstance from "@/config/axios/api-client.config";
import { handleApiRequest } from "@/lib/utils";
import { MoodboardAsset, PaginatedGenerationsResponse } from "@/types/types";
import { z, ZodTypeAny } from "zod";

export const generateImage = async <T extends ZodTypeAny>(
  brandId: string,
  data: z.infer<T>
) => {
  try {
    await handleApiRequest(
      axiosInstance.post(`/brands/${brandId}/a2i/image-generation`, {
        ...data,
      })
    );
  } catch (error) {
    console.error("Error generating image:", error);
    throw error;
  }
};

export const deleteA2iImage = async (
  brandId: string,
  generationId: string,
  imageId: string | null
) => {
  try {
    await handleApiRequest(
      axiosInstance.delete(`/brands/${brandId}/a2i/images`, {
        data: {
          generation_id: generationId,
          image_id: imageId,
        },
      })
    );
  } catch (error) {
    console.error("Error deleting image:", error);
    throw error;
  }
};

export const toggleA2iImageLike = async (
  brandId: string,
  generationId: string,
  imageId: string,
  isLiked: boolean
) => {
  try {
    await handleApiRequest(
      axiosInstance.put(`/brands/${brandId}/a2i/images`, {
        generation_id: generationId,
        image_id: imageId,
        is_liked: isLiked,
      })
    );
  } catch (error) {
    console.error("Error toggling image like status:", error);
    throw error;
  }
};

export const updateA2iImagePositions = async (
  brandId: string,
  updates: {
    generation_id: string;
    image_id: string;
    position: number;
  }[]
) => {
  try {
    await handleApiRequest(
      axiosInstance.put(`/brands/${brandId}/a2i/images/positions`, {
        updates,
      })
    );
  } catch (error) {
    console.error("Failed to update image positions:", error);
    throw error;
  }
};

export const getGenerations = async (
  brandId: string,
  skip: number = 0,
  limit: number = 20,
  campaignId?: string | null,
  subFolderId?: string | null,
): Promise<PaginatedGenerationsResponse> => {
  const params = new URLSearchParams({ skip: String(skip), limit: String(limit) });
  if (campaignId) params.set("campaign_id", campaignId);
  if (subFolderId) params.set("sub_folder_id", subFolderId);
  return handleApiRequest<PaginatedGenerationsResponse>(
    axiosInstance.get(`/brands/${brandId}/a2i/generations?${params}`)
  );
};

export const updateA2iRefernceMoodboard = async (
  brandId: string,
  moodboardId: string | null,
  referenceMoodboardAssets?: MoodboardAsset[]
) => {
  try {
    await handleApiRequest(
      axiosInstance.patch(`/brands/a2i/reference-moodboard`, {
        moodboard_id: moodboardId,
        brand_id: brandId,
        reference_moodboard_assets: referenceMoodboardAssets,
      })
    );
  } catch (error) {
    console.error("Error updating reference moodboard:", error);
    throw error;
  }
};
